import React, {Suspense} from 'react';

import notesIcon from '@raison/static/icons/apps-line.svg';
import cryptoIcon from '@raison/static/icons/bit-coin-line.svg';
import cashIcon from '@raison/static/icons/coins-line.svg';
import bondsIcon from '@raison/static/icons/file-copy-2-line.svg';
import privateEquityIcon from '@raison/static/icons/funds-line.svg';
import stockIcon from '@raison/static/icons/stock-line.svg';

import {useSelector} from 'react-redux';
import {DashboardCategoryLink, DashboardCategoryTotal} from '~/entities/dashboard-categories';
import {PromptToCompleteKyc} from '~/entities/dialogs';
import {HomePageBanner} from '~/processes/dashboard/components/HomePageBanner/HomePageBanner';
import {TotalBalanceToast} from '~/processes/dashboard/components/TotalBalance';
import {useAppDispatch} from '~/shared/store';
import HomePageActionsButtonGroup from './components/HomePageActionsButtonGroup/HomePageActionsButtonGroup';
import {HomeDashboardLayout, HomeLinksLayout, HomePageLayout} from './components/layouts';

export function DemoHomePages(props: {
    alerts?: React.JSX.Element;
    selectZeroTotal: AppSelector<DashboardCategoryTotal>;
}) {
    const zeroTotals = useSelector(props.selectZeroTotal);

    const dispatch = useAppDispatch();

    const onFeatureClick = () => {
        dispatch(PromptToCompleteKyc.open());
    };

    return (
        <HomePageLayout>
            <HomeDashboardLayout>
                {props.alerts}

                <TotalBalanceToast useBalance={() => zeroTotals.balance} portions={[]} />
                <Suspense fallback={<HomePageBanner.Skeleton />}>
                    <HomePageBanner />
                </Suspense>
                <HomePageActionsButtonGroup
                    onReceiveClick={onFeatureClick}
                    onExchangeClick={onFeatureClick}
                    onSendClick={onFeatureClick}
                />
            </HomeDashboardLayout>

            <HomeLinksLayout>
                <DashboardCategoryLink.Stub
                    icon={cashIcon}
                    title='Cash'
                    kindPlural='accounts'
                    kindSingular='account'
                    details={zeroTotals}
                    onClick={onFeatureClick}
                />
                <DashboardCategoryLink.Stub
                    icon={cryptoIcon}
                    title='Crypto'
                    kindPlural='accounts'
                    kindSingular='account'
                    details={zeroTotals}
                    onClick={onFeatureClick}
                />
                <DashboardCategoryLink.Stub
                    icon={privateEquityIcon}
                    title='Private equity'
                    kindPlural='instruments'
                    kindSingular='instrument'
                    details={zeroTotals}
                    onClick={onFeatureClick}
                />
                <DashboardCategoryLink.Stub
                    title={'Stocks & ETFs'}
                    icon={stockIcon}
                    kindPlural='instruments'
                    kindSingular='instrument'
                    details={zeroTotals}
                    onClick={onFeatureClick}
                />
                <DashboardCategoryLink.Stub
                    title={'Bonds'}
                    icon={bondsIcon}
                    kindPlural='instruments'
                    kindSingular='instrument'
                    details={zeroTotals}
                    onClick={onFeatureClick}
                />
                <DashboardCategoryLink.Stub
                    title={'Structured Notes'}
                    icon={notesIcon}
                    kindPlural='instruments'
                    kindSingular='instrument'
                    details={zeroTotals}
                    onClick={onFeatureClick}
                />
            </HomeLinksLayout>
        </HomePageLayout>
    );
}
